'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var translateAndRotate = (0, _utils.compose)(_utils.translate3d, _utils.rotate3d);


var rollOut = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: translateAndRotate(['100%', 0, 0], [0, 0, 1, 120])
  }
};

exports.default = rollOut;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/roll-out.js
// module id = 2148
// module chunks = 0